import { white, gray7 } from '@spotify-internal/encore-foundation';
import { Type } from '@spotify-internal/encore-creator-web';
import styled from 'styled-components';

import { isDarkTheme } from './';

export const Text = styled(Type).attrs(({ theme }) => ({
  variant: Type.body2,
  color: isDarkTheme(theme) ? white : gray7,
}))``;
